export const EMPTY_OPTION_VALUE = 'Select option';
